/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchDirectorFinancialDetailsResponsePrograms,
  FetchDirectorFinancialDetailsResponseProgramsFromJSON,
  FetchDirectorFinancialDetailsResponseProgramsToJSON,
} from './'

/**
 * Financial details for a given director, including amounts owed by tutors and families.
 * @export
 * @interface FetchDirectorFinancialDetailsResponse
 */
export interface FetchDirectorFinancialDetailsResponse {
  /**
   * List of programs associated with the director.
   * @type {Array<FetchDirectorFinancialDetailsResponsePrograms>}
   * @memberof FetchDirectorFinancialDetailsResponse
   */
  programs: Array<FetchDirectorFinancialDetailsResponsePrograms>
}

export function FetchDirectorFinancialDetailsResponseFromJSON(
  json: any
): FetchDirectorFinancialDetailsResponse {
  return FetchDirectorFinancialDetailsResponseFromJSONTyped(json, false)
}

export function FetchDirectorFinancialDetailsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchDirectorFinancialDetailsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programs: (json['programs'] as Array<any>).map(
      FetchDirectorFinancialDetailsResponseProgramsFromJSON
    ),
  }
}

export function FetchDirectorFinancialDetailsResponseToJSON(
  value?: FetchDirectorFinancialDetailsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programs: (value.programs as Array<any>).map(
      FetchDirectorFinancialDetailsResponseProgramsToJSON
    ),
  }
}
